<template>
	<div  class="pages-result__img-col">
		<template v-if="imageUrl">
			<img :src="imageUrl + '?hei=90'" :alt="title" class="pages-result__img">
		</template>
		<template v-else>
			<div class="pages-result__icon">
				<span class="icon-contact-form"></span>
			</div>
		</template>
	</div>
</template>

<script lang="ts">
export default {
	name: "News",
	props: {
		imageUrl: {
			type: String,
			default: ""
		},
		title: {
			type: String,
			default: ""
		}
	}
};
</script>
